/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Export_Field_Pattern_IdInputs */



/**
* | output |
* | --- |
* | "Pattern ID" |
*
* @param {Audit_Export_Field_Pattern_IdInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_export_field_pattern_id = /** @type {((inputs?: Audit_Export_Field_Pattern_IdInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Export_Field_Pattern_IdInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Muster-ID")
	return /** @type {LocalizedString} */ ("Pattern ID")
});